"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "edit-modal booking-modal eh-popup-panel" };
var _hoisted_2 = { class: "edit-header" };
var _hoisted_3 = { class: "modal-body" };
var _hoisted_4 = { class: "booking-summary" };
var _hoisted_5 = { class: "bs-value" };
var _hoisted_6 = { class: "form-row" };
var _hoisted_7 = ["disabled"];
var _hoisted_8 = { value: "" };
var _hoisted_9 = ["label"];
var _hoisted_10 = ["value"];
var _hoisted_11 = {
    key: 0,
    class: "form-error"
};
var _hoisted_12 = {
    key: 1,
    class: "form-hint"
};
var _hoisted_13 = { class: "form-row" };
var _hoisted_14 = ["disabled"];
var _hoisted_15 = ["value"];
var _hoisted_16 = { class: "form-row" };
var _hoisted_17 = { class: "mini-month" };
var _hoisted_18 = { class: "mini-month-head" };
var _hoisted_19 = { class: "mini-month-grid" };
var _hoisted_20 = ["onClick"];
var _hoisted_21 = { class: "form-row two-col" };
var _hoisted_22 = ["disabled"];
var _hoisted_23 = ["value"];
var _hoisted_24 = ["value"];
var _hoisted_25 = {
    key: 0,
    class: "no-slots-hint"
};
var _hoisted_26 = { class: "form-row" };
var _hoisted_27 = {
    key: 0,
    class: "viability-reasons"
};
var _hoisted_28 = { class: "notify-row" };
var _hoisted_29 = { class: "notify-toggle" };
var _hoisted_30 = { class: "notify-recipients" };
var _hoisted_31 = { class: "notify-method" };
var _hoisted_32 = {
    key: 0,
    class: "group-select-wrap"
};
var _hoisted_33 = ["label"];
var _hoisted_34 = ["value"];
var _hoisted_35 = {
    key: 2,
    class: "form-error"
};
var _hoisted_36 = { class: "edit-footer" };
var _hoisted_37 = ["disabled"];
var _hoisted_38 = {
    key: 0,
    class: "glyphicon glyphicon-refresh spinning"
};
var _hoisted_39 = {
    key: 1,
    class: "glyphicon glyphicon-ok"
};
var vue_3 = require("vue");
var patientCardsStore_1 = require("../../../stores/patientCardsStore");
var useSchedulingAccess_1 = require("@/composables/useSchedulingAccess");
var appointmentApiService_1 = require("../../../services/appointmentApiService");
var patientAvailabilityService_1 = require("../../../services/patientAvailabilityService");
exports.default = (0, vue_1.defineComponent)({
    __name: 'MasterCalendarBookingModal',
    props: {
        accountnumber: {},
        patientId: {},
        patientName: {},
        initialDate: {},
        initialTime: {},
        editEvent: {},
        access: {}
    },
    emits: ["close", "saved"],
    setup: function (__props, _a) {
        var _this = this;
        var _b, _c, _d, _e, _f;
        var __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var isEdit = (0, vue_3.computed)(function () { return !!props.editEvent; });
        var store = (0, patientCardsStore_1.usePatientCardsStore)();
        /* ---------- Care team — one fetch, two derived views ----------
         * findPatientGroups() already backs the group-notification picker
         * (SchedulingCalendar.vue / AppointmentModule.vue) — same patient, same
         * proto_groups/proto_group_members data, segmented by role (Providers,
         * Nurses, HHA, etc.). Reused here for both the Caregiver picker (cross-
         * referenced against store.providers/nurses for credential/category, which
         * the group endpoint itself doesn't return) and the Notify "Groups" picker
         * (raw shape, same as the other two consumers). */
        var groupOptions = (0, vue_3.ref)([]);
        var loadingCareTeam = (0, vue_3.ref)(true);
        function loadCareTeamGroups() {
            return __awaiter(this, void 0, void 0, function () {
                var res;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            loadingCareTeam.value = true;
                            return [4 /*yield*/, (0, appointmentApiService_1.findPatientGroups)(props.patientId)];
                        case 1:
                            res = _b.sent();
                            groupOptions.value = ((_a = res === null || res === void 0 ? void 0 : res.groups) !== null && _a !== void 0 ? _a : []).filter(function (g) { var _a; return ((_a = g.members) === null || _a === void 0 ? void 0 : _a.length) > 0; });
                            loadingCareTeam.value = false;
                            return [2 /*return*/];
                    }
                });
            });
        }
        var caregiverGroups = (0, vue_3.computed)(function () {
            return groupOptions.value
                .map(function (g) { return ({
                groupId: g.groupId,
                groupName: g.groupName,
                // filterStaffForAccess narrows each group's members to just the
                // caller for a locked caregiver session -- see its own header.
                members: (0, useSchedulingAccess_1.filterStaffForAccess)(g.members
                    .map(function (m) {
                    var staff = store.providers.find(function (p) { return p.id === m.pid; }) || store.nurses.find(function (n) { return n.id === m.pid; });
                    return staff ? { id: m.pid, name: staff.name, category: staff.category || 'provider', credential: staff.credential, specialty: staff.specialty } : null;
                })
                    .filter(function (m) { return m !== null; }), props.access)
            }); })
                .filter(function (g) { return g.members.length > 0; });
        });
        var allCaregivers = (0, vue_3.computed)(function () { return caregiverGroups.value.flatMap(function (g) { return g.members; }); });
        var selectedCaregiverId = (0, vue_3.ref)(((_b = props.editEvent) === null || _b === void 0 ? void 0 : _b.caregiverId) || '');
        var selectedCaregiver = (0, vue_3.computed)(function () { return allCaregivers.value.find(function (m) { return m.id === selectedCaregiverId.value; }); });
        var caregiverType = (0, vue_3.computed)(function () {
            return selectedCaregiver.value
                ? (0, appointmentApiService_1.caregiverTypeForCredential)(selectedCaregiver.value.credential || selectedCaregiver.value.specialty || '', selectedCaregiver.value.category)
                : null;
        });
        var contextOptions = (0, vue_3.computed)(function () { return caregiverType.value ? (0, appointmentApiService_1.visitContextsForCaregiverType)(caregiverType.value) : []; });
        var selectedContext = (0, vue_3.ref)(((_c = props.editEvent) === null || _c === void 0 ? void 0 : _c.context) || '');
        // A reschedule's context is locked to the original visit's, even if it isn't
        // (or isn't yet, before caregiverGroups loads) among the resolved caregiver
        // type's current options — never clear it out from under an in-flight edit.
        (0, vue_3.watch)(contextOptions, function (opts) {
            if (isEdit.value)
                return;
            if (selectedContext.value && !opts.includes(selectedContext.value))
                selectedContext.value = '';
        });
        function caregiverTypeForStaffId(staffId) {
            var m = allCaregivers.value.find(function (c) { return c.id === staffId; });
            return m ? (0, appointmentApiService_1.caregiverTypeForCredential)(m.credential || m.specialty || '', m.category) : null;
        }
        /* ---------- Date / time / duration / reason ---------- */
        var WEEKDAY_NAMES = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
        function toDateStr(d) { return d.toISOString().split('T')[0]; }
        function mondayOf(d) {
            var copy = new Date(d);
            var dow = copy.getDay();
            copy.setDate(copy.getDate() + (dow === 0 ? -6 : 1 - dow));
            copy.setHours(0, 0, 0, 0);
            return copy;
        }
        function addDays(d, n) { var c = new Date(d); c.setDate(c.getDate() + n); return c; }
        function shiftMonth(d, n) { return new Date(d.getFullYear(), d.getMonth() + n, 1); }
        function toMin(time) { var _a = time.split(':').map(Number), h = _a[0], m = _a[1]; return h * 60 + m; }
        function minToHHMM(min) { return "".concat(String(Math.floor(min / 60)).padStart(2, '0'), ":").concat(String(min % 60).padStart(2, '0')); }
        var bookingDate = (0, vue_3.ref)(((_d = props.editEvent) === null || _d === void 0 ? void 0 : _d.date) || props.initialDate);
        var bookingTime = (0, vue_3.ref)(props.editEvent ? minToHHMM(props.editEvent.startMin) : (props.initialTime || ''));
        var bookingDuration = (0, vue_3.ref)(props.editEvent ? props.editEvent.endMin - props.editEvent.startMin : 60);
        var bookingReason = (0, vue_3.ref)(((_e = props.editEvent) === null || _e === void 0 ? void 0 : _e.reason) || '');
        var bookingSlots = (0, vue_3.ref)([]);
        var durationOptions = [
            { value: 30, label: '30 min' },
            { value: 45, label: '45 min' },
            { value: 60, label: '1 hour' },
            { value: 90, label: '1.5 hours' },
            { value: 120, label: '2 hours' }
        ];
        var miniMonthAnchor = (0, vue_3.ref)(new Date((((_f = props.editEvent) === null || _f === void 0 ? void 0 : _f.date) || props.initialDate) + 'T00:00:00'));
        var miniMonthLabel = (0, vue_3.computed)(function () { return miniMonthAnchor.value.toLocaleDateString(undefined, { month: 'long', year: 'numeric' }); });
        var miniMonthCells = (0, vue_3.computed)(function () {
            var firstOfMonth = new Date(miniMonthAnchor.value.getFullYear(), miniMonthAnchor.value.getMonth(), 1);
            var gridStart = mondayOf(firstOfMonth);
            return Array.from({ length: 42 }, function (_, i) {
                var d = addDays(gridStart, i);
                return { dateStr: toDateStr(d), dayNum: d.getDate(), inMonth: d.getMonth() === miniMonthAnchor.value.getMonth() };
            });
        });
        function selectBookingDate(dateStr) { bookingDate.value = dateStr; bookingTime.value = ''; }
        // Defaults the Start Time to "now," rounded to whichever open slot is
        // closest — only when nothing's already picked (e.g. a click-to-book
        // prefill from a specific week/day slot should win over this).
        function closestSlotToNow(slots, date) {
            var now = new Date();
            if (date !== toDateStr(now))
                return slots[0].value;
            var nowMin = now.getHours() * 60 + now.getMinutes();
            var closest = slots[0];
            var closestDiff = Math.abs(toMin(closest.value) - nowMin);
            for (var _i = 0, slots_1 = slots; _i < slots_1.length; _i++) {
                var s = slots_1[_i];
                var diff = Math.abs(toMin(s.value) - nowMin);
                if (diff < closestDiff) {
                    closest = s;
                    closestDiff = diff;
                }
            }
            return closest.value;
        }
        var caregiverRules = (0, vue_3.ref)([]);
        var caregiverTimeOffRaw = (0, vue_3.ref)([]);
        function loadCaregiverSchedule() {
            return __awaiter(this, void 0, void 0, function () {
                var _a, rules, timeOff;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!selectedCaregiverId.value) {
                                caregiverRules.value = [];
                                caregiverTimeOffRaw.value = [];
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, Promise.all([
                                    (0, appointmentApiService_1.getAvailabilityRules)(props.accountnumber, selectedCaregiverId.value),
                                    (0, appointmentApiService_1.getTimeOff)(props.accountnumber, selectedCaregiverId.value)
                                ])];
                        case 1:
                            _a = _b.sent(), rules = _a[0], timeOff = _a[1];
                            caregiverRules.value = rules;
                            caregiverTimeOffRaw.value = timeOff;
                            return [2 /*return*/];
                    }
                });
            });
        }
        (0, vue_3.watch)(selectedCaregiverId, loadCaregiverSchedule, { immediate: true });
        var caregiverAppointments = (0, vue_3.computed)(function () { return store.appointments.filter(function (a) { return a.providerId === selectedCaregiverId.value; }); });
        // Nurses/HHAs work shifts, not fixed-length appointment slots — a rule's
        // slot_minutes there means "typical shift length" (which can legitimately
        // exceed the window, e.g. a 12-hour shift), not a granular booking
        // increment. Feeding that into the provider-oriented getAvailability()/
        // computeAvailableSlots() path collapses the whole shift into ONE slot
        // spanning the entire window, so a single partial-day booking makes the
        // caregiver's entire shift look fully booked (see SchedulingCalendar.vue's
        // identical isShiftBased/buildShiftBookingSlots, which this mirrors so both
        // booking flows treat shift-based staff the same way).
        var isShiftBased = (0, vue_3.computed)(function () { var _a, _b; return ((_a = selectedCaregiver.value) === null || _a === void 0 ? void 0 : _a.category) === 'nurse' || ((_b = selectedCaregiver.value) === null || _b === void 0 ? void 0 : _b.category) === 'hha'; });
        function formatSlotLabel(hhmm) {
            var _a = hhmm.split(':').map(Number), h = _a[0], m = _a[1];
            var period = h >= 12 ? 'PM' : 'AM';
            var hr = h % 12 === 0 ? 12 : h % 12;
            return "".concat(hr, ":").concat(String(m).padStart(2, '0'), " ").concat(period);
        }
        function buildShiftBookingSlots(dateStr) {
            var _a;
            var dow = new Date(dateStr + 'T00:00:00').getDay();
            var dayRules = caregiverRules.value.filter(function (r) { return r.dayOfWeek === dow; });
            if (dayRules.length === 0)
                return [];
            var blocked = [];
            for (var _i = 0, _b = caregiverTimeOffRaw.value; _i < _b.length; _i++) {
                var off = _b[_i];
                if (off.offDate !== dateStr)
                    continue;
                blocked.push({
                    start: off.startTime ? toMin(off.startTime) : 0,
                    end: off.endTime ? toMin(off.endTime) : 24 * 60
                });
            }
            for (var _c = 0, _d = caregiverAppointments.value; _c < _d.length; _c++) {
                var a = _d[_c];
                if (a.date !== dateStr || a.status === 'cancelled')
                    continue;
                if (props.editEvent && a.id === props.editEvent.id)
                    continue;
                var start = toMin(a.time);
                blocked.push({ start: start, end: start + ((_a = a.durationMinutes) !== null && _a !== void 0 ? _a : 60) });
            }
            var STEP = 30;
            var results = [];
            for (var _e = 0, dayRules_1 = dayRules; _e < dayRules_1.length; _e++) {
                var rule = dayRules_1[_e];
                var windowStart = toMin(rule.startTime);
                var windowEnd = toMin(rule.endTime);
                if (windowEnd <= windowStart)
                    continue;
                var _loop_1 = function (t) {
                    if (blocked.some(function (b) { return t >= b.start && t < b.end; }))
                        return "continue";
                    var nextBoundary = Math.min.apply(Math, __spreadArray([windowEnd], blocked.filter(function (b) { return b.start > t; }).map(function (b) { return b.start; }), false));
                    var room = nextBoundary - t;
                    if (room < STEP)
                        return "continue";
                    var value = minToHHMM(t);
                    results.push({ value: value, label: formatSlotLabel(value), durationMinutes: room });
                };
                for (var t = windowStart; t < windowEnd; t += STEP) {
                    _loop_1(t);
                }
            }
            return results;
        }
        // bookingSlots is already filtered to available-only by getAvailability —
        // same behavior SchedulingCalendar.vue's New Visit modal uses, confirmed
        // sufficient (a taken time simply can't be selected, no strikethrough UI
        // needed). This filtering also does the heavy lifting for the "does this
        // caregiver already have ANY conflicting visit" check server-side, across
        // every one of their patients — not just this one, which store.appointments
        // can't see for a genuine patient session (privacy-scoped to their own data).
        // Shift-based staff (nurse/HHA) skip this entirely and use
        // buildShiftBookingSlots instead — see isShiftBased above.
        var bookingSlotsRequestId = 0;
        var loadingSlots = (0, vue_3.ref)(false);
        function loadBookingSlots() {
            return __awaiter(this, void 0, void 0, function () {
                var requestId, slots, res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            requestId = ++bookingSlotsRequestId;
                            bookingSlots.value = [];
                            if (!bookingDate.value || !selectedCaregiverId.value)
                                return [2 /*return*/];
                            loadingSlots.value = true;
                            if (!isShiftBased.value) return [3 /*break*/, 1];
                            slots = buildShiftBookingSlots(bookingDate.value);
                            return [3 /*break*/, 3];
                        case 1: return [4 /*yield*/, (0, appointmentApiService_1.getAvailability)(props.accountnumber, selectedCaregiverId.value, bookingDate.value)];
                        case 2:
                            res = _a.sent();
                            slots = res.slots
                                .filter(function (s) { return s.available && !s.booked && !s.capped; })
                                .map(function (s) { var _a; return ({ value: s.value, label: s.label, durationMinutes: (_a = s.durationMinutes) !== null && _a !== void 0 ? _a : 60 }); });
                            _a.label = 3;
                        case 3:
                            if (requestId !== bookingSlotsRequestId)
                                return [2 /*return*/];
                            bookingSlots.value = slots;
                            loadingSlots.value = false;
                            if (!bookingTime.value && slots.length) {
                                bookingTime.value = closestSlotToNow(slots, bookingDate.value);
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
        // caregiverRules/caregiverTimeOffRaw as dependencies too — loadCaregiverSchedule
        // resolves independently (its own watcher above), so for a shift-based
        // caregiver this re-runs once those actually arrive rather than computing
        // shift slots against a momentarily-empty schedule.
        (0, vue_3.watch)([bookingDate, selectedCaregiverId, caregiverRules, caregiverTimeOffRaw], loadBookingSlots, { immediate: true });
        // The Start Time dropdown only ever lists genuinely open slots — a taken
        // time simply can't be selected, by design (see the comment above
        // loadBookingSlots). Without an explanation, an empty dropdown reads as
        // broken rather than "this caregiver has nothing open here." Surfaced only
        // once a caregiver + date are both picked and the (non-stale) fetch has
        // actually finished, so it never flashes during the brief loading window.
        var showNoSlotsHint = (0, vue_3.computed)(function () {
            return !loadingSlots.value && !!selectedCaregiverId.value && !!bookingDate.value && bookingSlots.value.length === 0;
        });
        var formattedBookingDate = (0, vue_3.computed)(function () {
            return bookingDate.value ? new Date(bookingDate.value + 'T00:00:00').toLocaleDateString(undefined, { month: 'short', day: 'numeric' }) : '';
        });
        /* ---------- Viability ---------- */
        var patientBlocksRaw = (0, vue_3.ref)([]);
        function loadPatientBlocks() {
            return __awaiter(this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = patientBlocksRaw;
                            return [4 /*yield*/, (0, patientAvailabilityService_1.getPatientBlocks)(props.accountnumber, props.patientId, 'in_home')];
                        case 1:
                            _a.value = _b.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
        function windowsForDow(dow) {
            return caregiverRules.value.filter(function (r) { return r.dayOfWeek === dow; }).map(function (r) { return ({ start: toMin(r.startTime), end: toMin(r.endTime) }); });
        }
        function timeOffForDate(dateStr) {
            return caregiverTimeOffRaw.value
                .filter(function (o) { return o.offDate === dateStr; })
                .map(function (o) { return ({ start: o.startTime ? toMin(o.startTime) : 0, end: o.endTime ? toMin(o.endTime) : 24 * 60 }); });
        }
        var maxConcurrentCaregivers = (0, vue_3.ref)(2);
        var patientAppointments = (0, vue_3.computed)(function () { return store.appointments.filter(function (a) { return a.patientId === props.patientId; }); });
        var viability = (0, vue_3.computed)(function () {
            if (!bookingDate.value || !bookingTime.value)
                return { decision: 'allowed', reasons: [] };
            var dow = new Date(bookingDate.value + 'T00:00:00').getDay();
            return (0, appointmentApiService_1.evaluateVisitViability)({
                date: bookingDate.value,
                time: bookingTime.value,
                duration: bookingDuration.value,
                excludeIds: props.editEvent ? new Set([props.editEvent.id]) : undefined,
                caregiverType: caregiverType.value,
                caregiverContext: selectedContext.value,
                selectedCaregiverId: selectedCaregiverId.value,
                caregiverAppointments: caregiverAppointments.value,
                patientAppointments: patientAppointments.value,
                resolveCaregiverType: caregiverTypeForStaffId,
                maxConcurrentCaregivers: maxConcurrentCaregivers.value,
                dayBlocks: (0, patientAvailabilityService_1.resolveBlocksForDate)(patientBlocksRaw.value, bookingDate.value),
                caregiverWindows: windowsForDow(dow),
                caregiverTimeOff: timeOffForDate(bookingDate.value)
            });
        });
        function viabilityIcon(decision) {
            if (decision === 'allowed')
                return 'bi-check-circle-fill viability-ok';
            if (decision === 'conditional')
                return 'bi-exclamation-triangle-fill viability-warn';
            return 'bi-x-circle-fill viability-bad';
        }
        function viabilityLabel(decision) {
            if (decision === 'allowed')
                return 'Allowed';
            if (decision === 'conditional')
                return 'Conditional — review before booking';
            return 'Blocked';
        }
        /* ---------- Notify ---------- */
        var notifyOn = (0, vue_3.ref)(false);
        var notifyCaregiver = (0, vue_3.ref)(false);
        var notifyGroups = (0, vue_3.ref)(false);
        var notifyMethod = (0, vue_3.ref)('email');
        var selectedGroupMembers = (0, vue_3.ref)([]);
        function notifyPayload() {
            if (!notifyOn.value)
                return undefined;
            var groupMembers = notifyGroups.value ? (0, appointmentApiService_1.resolveGroupMembers)(groupOptions.value, selectedGroupMembers.value) : [];
            if (!notifyCaregiver.value && groupMembers.length === 0)
                return undefined;
            return { notifyPatient: false, notifyCaregiver: notifyCaregiver.value, groupMembers: groupMembers, method: notifyMethod.value };
        }
        /* ---------- Save ---------- */
        var bookingError = (0, vue_3.ref)('');
        var savingBooking = (0, vue_3.ref)(false);
        var canConfirmBooking = (0, vue_3.computed)(function () {
            return !!(bookingDate.value && bookingTime.value && selectedCaregiverId.value && selectedContext.value) &&
                viability.value.decision !== 'blocked';
        });
        // Confirming a conditional verdict is what books it; the API records who did
        // (SchedulingCalendar.vue's confirmConditional, which this mirrors). The
        // server's own "conditional", when this preview showed none, is asked here and
        // sent with the next Confirm; changing the visit clears it.
        var serverAskedConfirmation = (0, vue_3.ref)(false);
        (0, vue_3.watch)([bookingDate, bookingTime, bookingDuration, selectedCaregiverId, selectedContext], function () {
            serverAskedConfirmation.value = false;
        });
        var confirmConditional = (0, vue_3.computed)(function () { return viability.value.decision === 'conditional' || serverAskedConfirmation.value; });
        function confirmBooking() {
            return __awaiter(this, void 0, void 0, function () {
                var res, res;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!canConfirmBooking.value)
                                return [2 /*return*/];
                            savingBooking.value = true;
                            bookingError.value = '';
                            if (!props.editEvent) return [3 /*break*/, 2];
                            return [4 /*yield*/, store.updateAppointment(props.editEvent.id, {
                                    patientId: props.patientId,
                                    providerId: props.editEvent.caregiverId,
                                    date: bookingDate.value,
                                    time: bookingTime.value,
                                    durationMinutes: bookingDuration.value,
                                    reason: bookingReason.value || undefined
                                }, notifyPayload(), { confirmConditional: confirmConditional.value })];
                        case 1:
                            res = _c.sent();
                            savingBooking.value = false;
                            // The server's sentence when it refused; the generic one otherwise.
                            if (!res.success) {
                                if (res.conditional)
                                    serverAskedConfirmation.value = true;
                                bookingError.value = res.error || 'Could not reschedule this visit. Please try again.';
                                return [2 /*return*/];
                            }
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, store.scheduleAppointment({
                                patientId: props.patientId,
                                providerId: selectedCaregiverId.value,
                                providerName: ((_a = selectedCaregiver.value) === null || _a === void 0 ? void 0 : _a.name) || '',
                                date: bookingDate.value,
                                time: bookingTime.value,
                                durationMinutes: bookingDuration.value,
                                meetingType: selectedContext.value,
                                reason: bookingReason.value || undefined,
                                notifyEmail: false,
                                notifySms: false,
                                // The discipline the verdict above was evaluated under, which the API
                                // needs for an allied professional (one account type, several columns).
                                caregiverType: (_b = caregiverType.value) !== null && _b !== void 0 ? _b : undefined
                            }, notifyPayload(), { confirmConditional: confirmConditional.value })];
                        case 3:
                            res = _c.sent();
                            savingBooking.value = false;
                            if (!res.success) {
                                if (res.conditional)
                                    serverAskedConfirmation.value = true;
                                bookingError.value = res.error || 'Could not schedule this visit. Please try again.';
                                return [2 /*return*/];
                            }
                            _c.label = 4;
                        case 4:
                            emit('saved');
                            emit('close');
                            return [2 /*return*/];
                    }
                });
            });
        }
        (0, vue_3.onMounted)(function () { return __awaiter(_this, void 0, void 0, function () {
            var uiSettings;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, loadCareTeamGroups()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, loadPatientBlocks()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, (0, appointmentApiService_1.getSchedulingUiSettings)(props.accountnumber)];
                    case 3:
                        uiSettings = _a.sent();
                        maxConcurrentCaregivers.value = uiSettings.maxConcurrentCaregivers;
                        return [2 /*return*/];
                }
            });
        }); });
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "body" }, [
                (0, vue_2.createVNode)(vue_2.Transition, { name: "modal" }, {
                    default: (0, vue_2.withCtx)(function () {
                        var _a;
                        return [
                            (0, vue_2.createElementVNode)("div", {
                                class: "modal-overlay eh-popup-overlay",
                                onClick: _cache[15] || (_cache[15] = (0, vue_2.withModifiers)(function ($event) { return (_ctx.$emit('close')); }, ["self"]))
                            }, [
                                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_2, [
                                        (0, vue_2.createElementVNode)("h3", null, (0, vue_2.toDisplayString)(isEdit.value ? 'Reschedule Visit' : 'New Appointment'), 1),
                                        (0, vue_2.createElementVNode)("button", {
                                            class: "modal-close",
                                            onClick: _cache[0] || (_cache[0] = function ($event) { return (_ctx.$emit('close')); })
                                        }, __spreadArray([], (_cache[16] || (_cache[16] = [
                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-remove" }, null, -1)
                                        ])), true))
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                                            (0, vue_2.createElementVNode)("div", null, [
                                                _cache[17] || (_cache[17] = (0, vue_2.createElementVNode)("span", { class: "bs-label" }, "Patient", -1)),
                                                (0, vue_2.createElementVNode)("span", _hoisted_5, (0, vue_2.toDisplayString)(_ctx.patientName), 1)
                                            ])
                                        ]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                            _cache[18] || (_cache[18] = (0, vue_2.createElementVNode)("label", null, "Caregiver", -1)),
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((selectedCaregiverId).value = $event); }),
                                                class: "pa-select",
                                                disabled: loadingCareTeam.value || isEdit.value
                                            }, [
                                                (0, vue_2.createElementVNode)("option", _hoisted_8, (0, vue_2.toDisplayString)(loadingCareTeam.value ? 'Loading care team…' : '— Select a caregiver —'), 1),
                                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(caregiverGroups.value, function (group) {
                                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("optgroup", {
                                                        key: group.groupId,
                                                        label: group.groupName
                                                    }, [
                                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(group.members, function (m) {
                                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                                key: m.id,
                                                                value: m.id
                                                            }, (0, vue_2.toDisplayString)(m.name) + (0, vue_2.toDisplayString)(m.specialty ? ' — ' + m.specialty : ''), 9, _hoisted_10));
                                                        }), 128))
                                                    ], 8, _hoisted_9));
                                                }), 128))
                                            ], 8, _hoisted_7), [
                                                [vue_2.vModelSelect, selectedCaregiverId.value]
                                            ]),
                                            (!loadingCareTeam.value && caregiverGroups.value.length === 0)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", _hoisted_11, "No care team members found for this patient."))
                                                : (0, vue_2.createCommentVNode)("", true),
                                            (isEdit.value)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", _hoisted_12, "Caregiver stays the same for a reschedule — cancel and book a new visit to change caregiver."))
                                                : (0, vue_2.createCommentVNode)("", true)
                                        ]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_13, [
                                            _cache[20] || (_cache[20] = (0, vue_2.createElementVNode)("label", null, "Context", -1)),
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((selectedContext).value = $event); }),
                                                class: "pa-select",
                                                disabled: !selectedCaregiverId.value || isEdit.value
                                            }, [
                                                _cache[19] || (_cache[19] = (0, vue_2.createElementVNode)("option", { value: "" }, "— Select context —", -1)),
                                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(contextOptions.value, function (ctx) {
                                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                        key: ctx,
                                                        value: ctx
                                                    }, (0, vue_2.toDisplayString)(ctx), 9, _hoisted_15));
                                                }), 128))
                                            ], 8, _hoisted_14), [
                                                [vue_2.vModelSelect, selectedContext.value]
                                            ])
                                        ]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_16, [
                                            _cache[23] || (_cache[23] = (0, vue_2.createElementVNode)("label", null, "Date", -1)),
                                            (0, vue_2.createElementVNode)("div", _hoisted_17, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_18, [
                                                    (0, vue_2.createElementVNode)("button", {
                                                        type: "button",
                                                        onClick: _cache[3] || (_cache[3] = function ($event) { return (miniMonthAnchor.value = shiftMonth(miniMonthAnchor.value, -1)); })
                                                    }, __spreadArray([], (_cache[21] || (_cache[21] = [
                                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-chevron-left bi-chevron-left" }, null, -1)
                                                    ])), true)),
                                                    (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(miniMonthLabel.value), 1),
                                                    (0, vue_2.createElementVNode)("button", {
                                                        type: "button",
                                                        onClick: _cache[4] || (_cache[4] = function ($event) { return (miniMonthAnchor.value = shiftMonth(miniMonthAnchor.value, 1)); })
                                                    }, __spreadArray([], (_cache[22] || (_cache[22] = [
                                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-chevron-right bi-chevron-right" }, null, -1)
                                                    ])), true))
                                                ]),
                                                (0, vue_2.createElementVNode)("div", _hoisted_19, [
                                                    ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(WEEKDAY_NAMES, function (wd) {
                                                        return (0, vue_2.createElementVNode)("span", {
                                                            key: wd,
                                                            class: "mini-wd"
                                                        }, (0, vue_2.toDisplayString)(wd[0]), 1);
                                                    }), 64)),
                                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(miniMonthCells.value, function (cell) {
                                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                                            type: "button",
                                                            key: cell.dateStr,
                                                            class: (0, vue_2.normalizeClass)(["mini-day", { 'out-month': !cell.inMonth, selected: cell.dateStr === bookingDate.value }]),
                                                            onClick: function ($event) { return (selectBookingDate(cell.dateStr)); }
                                                        }, (0, vue_2.toDisplayString)(cell.dayNum), 11, _hoisted_20));
                                                    }), 128))
                                                ])
                                            ])
                                        ]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_21, [
                                            (0, vue_2.createElementVNode)("div", null, [
                                                _cache[25] || (_cache[25] = (0, vue_2.createElementVNode)("label", null, "Start Time", -1)),
                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) { return ((bookingTime).value = $event); }),
                                                    class: "pa-select",
                                                    disabled: !selectedCaregiverId.value
                                                }, [
                                                    _cache[24] || (_cache[24] = (0, vue_2.createElementVNode)("option", { value: "" }, "— Select —", -1)),
                                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(bookingSlots.value, function (slot) {
                                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                            key: slot.value,
                                                            value: slot.value
                                                        }, (0, vue_2.toDisplayString)(slot.label), 9, _hoisted_23));
                                                    }), 128))
                                                ], 8, _hoisted_22), [
                                                    [vue_2.vModelSelect, bookingTime.value]
                                                ])
                                            ]),
                                            (0, vue_2.createElementVNode)("div", null, [
                                                _cache[26] || (_cache[26] = (0, vue_2.createElementVNode)("label", null, "Duration", -1)),
                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) { return ((bookingDuration).value = $event); }),
                                                    class: "pa-select"
                                                }, [
                                                    ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(durationOptions, function (opt) {
                                                        return (0, vue_2.createElementVNode)("option", {
                                                            key: opt.value,
                                                            value: opt.value
                                                        }, (0, vue_2.toDisplayString)(opt.label), 9, _hoisted_24);
                                                    }), 64))
                                                ], 512), [
                                                    [
                                                        vue_2.vModelSelect,
                                                        bookingDuration.value,
                                                        void 0,
                                                        { number: true }
                                                    ]
                                                ])
                                            ])
                                        ]),
                                        (showNoSlotsHint.value)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", _hoisted_25, [
                                                _cache[27] || (_cache[27] = (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-info-circle-fill" }, null, -1)),
                                                (0, vue_2.createTextVNode)(" No open times for " + (0, vue_2.toDisplayString)(((_a = selectedCaregiver.value) === null || _a === void 0 ? void 0 : _a.name) || 'this caregiver') + " on " + (0, vue_2.toDisplayString)(formattedBookingDate.value) + " — every slot is already booked or blocked by time off/availability hours. Try another date or caregiver. ", 1)
                                            ]))
                                            : (0, vue_2.createCommentVNode)("", true),
                                        (0, vue_2.createElementVNode)("div", _hoisted_26, [
                                            _cache[28] || (_cache[28] = (0, vue_2.createElementVNode)("label", null, [
                                                (0, vue_2.createTextVNode)("Reason "),
                                                (0, vue_2.createElementVNode)("span", { class: "optional" }, "(optional)")
                                            ], -1)),
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) { return ((bookingReason).value = $event); }),
                                                placeholder: "e.g. Follow-up, Wound check"
                                            }, null, 512), [
                                                [vue_2.vModelText, bookingReason.value]
                                            ])
                                        ]),
                                        (bookingDate.value && bookingTime.value)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                key: 1,
                                                class: (0, vue_2.normalizeClass)(["viability-panel", viability.value.decision])
                                            }, [
                                                (0, vue_2.createElementVNode)("span", {
                                                    class: (0, vue_2.normalizeClass)(["glyphicon", viabilityIcon(viability.value.decision)])
                                                }, null, 2),
                                                (0, vue_2.createElementVNode)("div", null, [
                                                    (0, vue_2.createElementVNode)("strong", null, (0, vue_2.toDisplayString)(viabilityLabel(viability.value.decision)), 1),
                                                    (viability.value.reasons.length)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("ul", _hoisted_27, [
                                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(viability.value.reasons, function (r) {
                                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", { key: r }, (0, vue_2.toDisplayString)(r), 1));
                                                            }), 128))
                                                        ]))
                                                        : (0, vue_2.createCommentVNode)("", true)
                                                ])
                                            ], 2))
                                            : (0, vue_2.createCommentVNode)("", true),
                                        (0, vue_2.createElementVNode)("div", _hoisted_28, [
                                            (0, vue_2.createElementVNode)("label", _hoisted_29, [
                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                    type: "checkbox",
                                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) { return ((notifyOn).value = $event); })
                                                }, null, 512), [
                                                    [vue_2.vModelCheckbox, notifyOn.value]
                                                ]),
                                                _cache[29] || (_cache[29] = (0, vue_2.createTextVNode)(" Notify of this visit ", -1))
                                            ]),
                                            (notifyOn.value)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_30, [
                                                        (0, vue_2.createElementVNode)("button", {
                                                            type: "button",
                                                            class: (0, vue_2.normalizeClass)(["notify-chip", { active: notifyCaregiver.value }]),
                                                            onClick: _cache[9] || (_cache[9] = function ($event) { return (notifyCaregiver.value = !notifyCaregiver.value); })
                                                        }, __spreadArray([], (_cache[30] || (_cache[30] = [
                                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-person-badge-fill" }, null, -1),
                                                            (0, vue_2.createTextVNode)(" Caregiver ", -1)
                                                        ])), true), 2),
                                                        (0, vue_2.createElementVNode)("button", {
                                                            type: "button",
                                                            class: (0, vue_2.normalizeClass)(["notify-chip", { active: notifyGroups.value }]),
                                                            onClick: _cache[10] || (_cache[10] = function ($event) { return (notifyGroups.value = !notifyGroups.value); })
                                                        }, __spreadArray([], (_cache[31] || (_cache[31] = [
                                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-people-fill" }, null, -1),
                                                            (0, vue_2.createTextVNode)(" Groups ", -1)
                                                        ])), true), 2)
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", _hoisted_31, [
                                                        (0, vue_2.createElementVNode)("button", {
                                                            type: "button",
                                                            class: (0, vue_2.normalizeClass)({ active: notifyMethod.value === 'sms' }),
                                                            onClick: _cache[11] || (_cache[11] = function ($event) { return (notifyMethod.value = 'sms'); })
                                                        }, "SMS", 2),
                                                        (0, vue_2.createElementVNode)("button", {
                                                            type: "button",
                                                            class: (0, vue_2.normalizeClass)({ active: notifyMethod.value === 'email' }),
                                                            onClick: _cache[12] || (_cache[12] = function ($event) { return (notifyMethod.value = 'email'); })
                                                        }, "Email", 2)
                                                    ]),
                                                    (notifyGroups.value)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("label", _hoisted_32, [
                                                            _cache[33] || (_cache[33] = (0, vue_2.createElementVNode)("span", { class: "group-select-label" }, "Care Team Groups", -1)),
                                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                                                multiple: "",
                                                                "onUpdate:modelValue": _cache[13] || (_cache[13] = function ($event) { return ((selectedGroupMembers).value = $event); }),
                                                                class: "group-select"
                                                            }, [
                                                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(groupOptions.value, function (group) {
                                                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("optgroup", {
                                                                        key: group.groupId,
                                                                        label: group.groupName
                                                                    }, [
                                                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(group.members, function (member) {
                                                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                                                key: member.pid,
                                                                                value: member.email
                                                                            }, (0, vue_2.toDisplayString)(member.patientName), 9, _hoisted_34));
                                                                        }), 128))
                                                                    ], 8, _hoisted_33));
                                                                }), 128)),
                                                                _cache[32] || (_cache[32] = (0, vue_2.createElementVNode)("optgroup", { label: "All Group Members" }, [
                                                                    (0, vue_2.createElementVNode)("option", { value: "All" }, "All Members")
                                                                ], -1))
                                                            ], 512), [
                                                                [vue_2.vModelSelect, selectedGroupMembers.value]
                                                            ])
                                                        ]))
                                                        : (0, vue_2.createCommentVNode)("", true)
                                                ], 64))
                                                : (0, vue_2.createCommentVNode)("", true)
                                        ]),
                                        (bookingError.value)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", _hoisted_35, (0, vue_2.toDisplayString)(bookingError.value), 1))
                                            : (0, vue_2.createCommentVNode)("", true)
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_36, [
                                        (0, vue_2.createElementVNode)("button", {
                                            class: "btn-cancel",
                                            onClick: _cache[14] || (_cache[14] = function ($event) { return (_ctx.$emit('close')); })
                                        }, "Cancel"),
                                        (0, vue_2.createElementVNode)("button", {
                                            class: "btn-save",
                                            disabled: !canConfirmBooking.value || savingBooking.value,
                                            onClick: confirmBooking
                                        }, [
                                            (savingBooking.value)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_38))
                                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_39)),
                                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(serverAskedConfirmation.value ? 'Confirm Conditional Visit' : (isEdit.value ? 'Save New Time' : 'Confirm Visit')), 1)
                                        ], 8, _hoisted_37)
                                    ])
                                ])
                            ])
                        ];
                    }, undefined, true),
                    _: 1
                })
            ]));
        };
    }
});
